module.exports = __webpack_public_path__ + "static/media/1POLICY10.9c9306c8.jpg";